export const getYoutubeId = (url?: string) => {
  if (!url) return;

  const id: string | string[] = url.split(
    /(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/,
  );

  return id[id.length - 1].split('?')[0];
};
